/*
 * DRT availability gate — status_livrare + preorder_eta.
 * Unifica PDP / Quick View / Quick Shop / carduri fara a duplica handleri.
 * Reguli:
 *  - variant.available (nativ Shopify) are prioritate absoluta; metafield-ul nu poate suprascrie.
 *  - Statusuri blocante (temporar indisponibil / in curand / indisponibil / la cerere):
 *    dezactiveaza CTA, ascunde dynamic checkout, blocheaza submit-ul.
 *  - Precomanda: cumparabil daca variant.available; mesaj + ETA prin textContent (nu innerHTML);
 *    injecteaza proprietati vizibile Precomanda=Da (+ Stoc estimat=[ETA] cand exista); dynamic checkout ascuns.
 *  - Alte statusuri / blank / necunoscut: comportament nativ (nu forteaza nimic).
 * Nu recalculeaza data in browser; afiseaza valoarea din metafield.
 * Idempotent: nu duplica inputuri; exact o valoare per proprietate la submituri repetate.
 */
(function () {
  if (window.__drtAvailabilityInit) return;
  window.__drtAvailabilityInit = true;

  var PROP_PRE = 'Precomandă';
  var PROP_ETA = 'Stoc estimat';
  var BLOCKING = { 'temporar indisponibil': 1, 'in curand': 1, 'indisponibil': 1, 'la cerere': 1 };
  var LABELS = {
    'temporar indisponibil': 'Temporar indisponibil',
    'in curand': 'În curând',
    'indisponibil': 'Indisponibil',
    'la cerere': 'La cerere',
    'precomanda': 'Precomandă'
  };
  // Selectori dynamic checkout (accelerated / Shopify Payment Button + custom elements).
  var PAYMENT_SEL = '.productView-payment, .shopify-payment-button, [data-shopify="payment-button"], .shopify-payment-button__button, shopify-accelerated-checkout, shopify-google-pay-button';
  function statusLabel(n) { return LABELS[n] || ''; }

  // Marker persistent pe formularul (ancestor stabil) al produsului: o regula CSS ascunde TOTI
  // descendentii payment, inclusiv nodurile re-injectate ulterior de SDK-ul Shopify -> fara timing JS.
  function setPaymentGate(form, on) {
    if (!form) return;
    if (on) { if (form.getAttribute('data-drt-payment-gated') !== '1') form.setAttribute('data-drt-payment-gated', '1'); }
    else if (form.hasAttribute('data-drt-payment-gated')) form.removeAttribute('data-drt-payment-gated');
  }
  // Injecteaza o singura data regula CSS scoped la formularul marcat (idempotent prin ID stabil).
  function injectPaymentGateStyle() {
    var id = 'drt-availability-payment-gate-style';
    if (document.getElementById(id)) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    if (!head) return;
    var st = document.createElement('style');
    st.id = id;
    st.textContent = 'form[action*="/cart/add"][data-drt-payment-gated="1"] .productView-payment,'
      + 'form[action*="/cart/add"][data-drt-payment-gated="1"] .shopify-payment-button,'
      + 'form[action*="/cart/add"][data-drt-payment-gated="1"] [data-shopify="payment-button"],'
      + 'form[action*="/cart/add"][data-drt-payment-gated="1"] .shopify-payment-button__button,'
      + 'form[action*="/cart/add"][data-drt-payment-gated="1"] shopify-accelerated-checkout,'
      + 'form[action*="/cart/add"][data-drt-payment-gated="1"] shopify-google-pay-button'
      + '{display:none !important;}';
    head.appendChild(st);
  }

  function norm(s) {
    if (s == null) return '';
    s = ('' + s).toLowerCase();
    s = s.replace(/[ăâ]/g, 'a').replace(/î/g, 'i').replace(/[șş]/g, 's').replace(/[țţ]/g, 't');
    return s.replace(/\s+/g, ' ').trim();
  }
  function isBlocking(n) { return Object.prototype.hasOwnProperty.call(BLOCKING, n); }
  function isPreorder(n) { return n === 'precomanda'; }

  function preMsg(eta) {
    if (eta) return 'Precomandă — stoc estimat: ' + eta + '. Expedierea începe imediat după recepție.';
    return 'Precomandă — expediere după recepția stocului.';
  }

  function parseData(el) {
    if (!el) return null;
    if (el.__drtParsed) return el.__drtParsed;
    try { el.__drtParsed = JSON.parse(el.textContent); } catch (e) { el.__drtParsed = null; }
    return el.__drtParsed;
  }

  function findDataEl(form) {
    var c = form.closest('.product-item, .quickView, .quickShop, .quickshop-popup, .productView, [data-quick-view], product-info');
    var d = c && c.querySelector('.drt-av-data');
    if (d) return d;
    var pid = form.getAttribute('data-product-id');
    if (!pid) { var m = ('' + (form.id || '')).match(/(\d{6,})/); if (m) pid = m[1]; }
    if (pid) { d = document.querySelector('.drt-av-data[data-product-id="' + pid + '"]'); if (d) return d; }
    var all = document.querySelectorAll('.drt-av-data');
    return all.length === 1 ? all[0] : null;
  }

  function selectedId(form) {
    var el = form.querySelector('[name="id"]');
    if (el && el.value) return el.value;
    var checked = form.querySelector('input[type="radio"][name="id"]:checked');
    if (checked && checked.value) return checked.value;
    return null;
  }

  function submitButtons(form) {
    return form.querySelectorAll('button[name="add"], button.product-form__submit, button[data-btn-addToCart]');
  }
  function dynamicEls(form) {
    return form.querySelectorAll(PAYMENT_SEL);
  }
  // Textul nativ de inventar DOAR in Quick View/Quick Shop (NU pe PDP, unde e deja corect).
  function inventoryValueEl(form) {
    var qv = form.closest('.quickView, .quickShop, .quickshop-popup, [data-quick-view]');
    if (!qv) return null;
    var inv = qv.querySelector('[data-inventory]');
    return inv ? inv.querySelector('.productView-info-value') : null;
  }
  function msgEl(dataEl) {
    if (!dataEl) return null;
    var scope = dataEl.parentNode || document;
    return scope.querySelector('.drt-av-msg');
  }

  function ourDisable(btn, on, nativeAvail) {
    if (on) {
      if (!btn.hasAttribute('data-drt-dis')) btn.setAttribute('data-drt-dis', '1');
      btn.classList.add('drt-blocked');
      if (btn.disabled !== true) btn.disabled = true;
    } else if (btn.hasAttribute('data-drt-dis')) {
      btn.removeAttribute('data-drt-dis');
      btn.classList.remove('drt-blocked');
      // Restaureaza la disponibilitatea nativa a variantei CURENTE (sold-out nativ ramane disabled).
      var want = nativeAvail === false;
      if (btn.disabled !== want) btn.disabled = want;
    }
  }
  function ourHide(el, on) {
    if (on) {
      if (!el.hasAttribute('data-drt-hid')) { el.setAttribute('data-drt-hid', el.style.display || ''); el.style.display = 'none'; }
    } else if (el.hasAttribute('data-drt-hid')) {
      el.style.display = el.getAttribute('data-drt-hid'); el.removeAttribute('data-drt-hid');
    }
  }
  // Blocare defensiva a dynamic checkout (rezista pana la re-render), izolata la elementul dat, cu ownership.
  function ourGate(el, on, nativeAvail) {
    if (on) {
      if (!el.hasAttribute('data-drt-gated')) {
        el.setAttribute('data-drt-gated', '1');
        el.setAttribute('data-drt-pe', el.style.pointerEvents || '');
        el.style.pointerEvents = 'none';
        // Adauga aria-disabled/tabindex DOAR daca nu exista nativ (le marcam ca ale DRT).
        if (!el.hasAttribute('aria-disabled')) { el.setAttribute('aria-disabled', 'true'); el.setAttribute('data-drt-aria', '1'); }
        if (!el.hasAttribute('tabindex')) { el.setAttribute('tabindex', '-1'); el.setAttribute('data-drt-tab', '1'); }
        if ('disabled' in el) { el.setAttribute('data-drt-dsbl', '1'); try { el.disabled = true; } catch (e) {} }
      }
    } else if (el.hasAttribute('data-drt-gated')) {
      el.style.pointerEvents = el.getAttribute('data-drt-pe') || '';
      el.removeAttribute('data-drt-pe');
      if (el.hasAttribute('data-drt-aria')) { el.removeAttribute('aria-disabled'); el.removeAttribute('data-drt-aria'); }
      if (el.hasAttribute('data-drt-tab')) { el.removeAttribute('tabindex'); el.removeAttribute('data-drt-tab'); }
      // Restaureaza disabled la disponibilitatea nativa a variantei curente (nu forta enabled orbeste).
      if (el.hasAttribute('data-drt-dsbl')) { if ('disabled' in el) { try { el.disabled = nativeAvail === false; } catch (e) {} } el.removeAttribute('data-drt-dsbl'); }
      el.removeAttribute('data-drt-gated');
    }
  }
  // Inlocuieste textul nativ de inventar cu eticheta custom, pastrand nativul pentru restaurare (idempotent).
  function setInvText(el, text) {
    if (!el) return;
    if (text) {
      if (!el.hasAttribute('data-drt-inv')) el.setAttribute('data-drt-inv', '1');
      if (el.textContent !== text) el.textContent = text;
    } else if (el.hasAttribute('data-drt-inv')) {
      // Nu restaura un snapshot cross-varianta: lasa valoarea nativa curenta (deja randata de tema).
      el.removeAttribute('data-drt-inv');
    }
  }

  function ensureProp(form, key, val) {
    var inp = form.querySelector('input[data-drt-prop="' + key + '"]');
    if (!inp) {
      inp = document.createElement('input');
      inp.type = 'hidden';
      inp.setAttribute('data-drt-prop', key);
      inp.name = 'properties[' + key + ']';
      form.appendChild(inp);
    }
    if (inp.value !== val) inp.value = val;
  }
  function removeProp(form, key) {
    var inp = form.querySelector('input[data-drt-prop="' + key + '"]');
    if (inp && inp.parentNode) inp.parentNode.removeChild(inp);
  }

  function setMsg(dataEl, text) {
    var m = msgEl(dataEl);
    if (!m) return;
    var t = text || '';
    if (m.textContent !== t) m.textContent = t;
    var hide = !t;
    if (m.hidden !== hide) m.hidden = hide;
  }

  function apply(form) {
    // GUARD CENTRAL: formularele neadministrate (ex. installment din Quick View, care partajeaza root-ul
    // cu formularul principal si i-ar mosteni statusul via findDataEl) NU primesc status. Curata doar
    // markerii DRT ramasi pe ele (upgrade din versiuni anterioare) si iesi inainte de findDataEl.
    if (!isManagedAvailabilityForm(form)) {
      setPaymentGate(form, false);
      if (form && form.hasAttribute && form.hasAttribute('data-drt-blocked')) form.removeAttribute('data-drt-blocked');
      return;
    }
    var dataEl = findDataEl(form);
    var data = parseData(dataEl);
    if (!data) return;
    var id = selectedId(form);
    // Card fara selector de varianta ([name=id] absent): lasa mesajul server-side + starea nativa intacte.
    if (id == null) return;
    var rec = id && data[id] ? data[id] : null;
    var status = norm(rec ? rec.s : '');
    var eta = rec && rec.e ? rec.e : '';
    var nativeAvail = rec ? rec.a !== false : true;

    var btns = submitButtons(form);
    var dyn = dynamicEls(form);
    var invEl = inventoryValueEl(form);
    var i;

    // Prioritate: statusul custom blocant castiga INDIFERENT de disponibilitatea nativa
    // (ex. native available=false + In Curand -> statusul custom trebuie sa prezinte si sa blocheze).
    if (isBlocking(status)) {
      form.setAttribute('data-drt-blocked', '1');
      setPaymentGate(form, true);
      for (i = 0; i < btns.length; i++) ourDisable(btns[i], true, nativeAvail);
      for (i = 0; i < dyn.length; i++) { ourHide(dyn[i], true); ourGate(dyn[i], true, nativeAvail); }
      removeProp(form, PROP_PRE); removeProp(form, PROP_ETA);
      setMsg(dataEl, statusLabel(status));
      setInvText(invEl, statusLabel(status));
      return;
    }

    form.removeAttribute('data-drt-blocked');
    for (i = 0; i < btns.length; i++) ourDisable(btns[i], false, nativeAvail);

    if (nativeAvail && isPreorder(status)) {
      setPaymentGate(form, true);
      for (i = 0; i < dyn.length; i++) { ourHide(dyn[i], true); ourGate(dyn[i], true, nativeAvail); }
      ensureProp(form, PROP_PRE, 'Da');
      if (eta) ensureProp(form, PROP_ETA, eta); else removeProp(form, PROP_ETA);
      setMsg(dataEl, preMsg(eta));
      setInvText(invEl, statusLabel('precomanda'));
      return;
    }

    // In Stoc / Livrare* / blank / necunoscut / varianta indisponibila nativ (fara status blocant) -> nativ.
    setPaymentGate(form, false);
    for (i = 0; i < dyn.length; i++) { ourHide(dyn[i], false); ourGate(dyn[i], false, nativeAvail); }
    removeProp(form, PROP_PRE); removeProp(form, PROP_ETA);
    setMsg(dataEl, '');
    setInvText(invEl, '');
  }

  function applySafe(form) { try { apply(form); } catch (e) { /* fail-open la nativ */ } }
  function scanAll() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) applySafe(forms[i]);
  }

  // Blocheaza submit-ul formularelor marcate.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.matches && f.matches('form[action*="/cart/add"]') && f.hasAttribute('data-drt-blocked')) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  // Formularul PRINCIPAL de add-to-cart din modalul Quick View / Quick Shop. NU formularul de installment,
  // care apare primul in DOM cu action=/cart/add dar nu contine CTA / .productView-payment / .drt-av-data.
  // Prefera data-type="add-to-cart-form"; fallback pe form.productView-action. Fara cautare globala.
  function quickProductForm(root) {
    if (!root || !root.querySelector) return null;
    return root.querySelector('form[data-type="add-to-cart-form"][action*="/cart/add"]')
      || root.querySelector('form.productView-action[action*="/cart/add"]');
  }

  // Formular gestionat de sistemul de disponibilitate. In afara Quick View/Quick Shop (PDP/carduri/alte
  // suprafete) orice form[action*=/cart/add] e gestionat. In interiorul unui modal, DOAR formularul principal
  // (nu cel de installment, care ar mosteni statusul din .drt-av-data comun prin findDataEl). Fara ordine DOM.
  function isManagedAvailabilityForm(form) {
    if (!form || !form.closest) return false;
    var root = form.closest('.quickView, .quickShop, .quickshop-popup, [data-quick-view], [data-quickshop]');
    if (!root) return true;
    return form === quickProductForm(root);
  }

  // Formularul produsului asociat unui control REAL de varianta (NU input[name=id]/quantity/cart).
  function variantControlForm(t) {
    if (!t || !t.closest) return null;
    if (t.name === 'id' || t.name === 'quantity') return null;
    var host = t.closest('variant-quick-view-selects, variant-quick-view-radios, variant-radios, variant-selects, .variant-picker, .variant_picker, .single-option, [data-quickshop]');
    if (!host) return null;
    // STRICT: doar in containerul modalului Quick View / Quick Shop (PDP/carduri nu au race de payment button
    // si sunt gestionate de fallback-urile existente). Nu folosi .productView/.product-item ca dovada suficienta.
    var root = t.closest('.quickView, .quickShop, .quickshop-popup, [data-quick-view], [data-quickshop]');
    if (!root) return null;
    // Tinteste formularul principal (cu payment), NU primul form[action*=/cart/add] (installment) din modal.
    return quickProductForm(root);
  }

  // Fallback: tema dispatch-uieste change pe hidden input[name=id] (variants-quick-view.js) cu ID-ul nou.
  // Il acceptam DOAR in Quick View/Quick Shop si DOAR daca formularul propriu al input-ului ESTE exact
  // formularul principal -> hidden ID-ul din installment (are si el [name=id]) si cel din PDP sunt ignorate.
  function quickIdForm(t) {
    if (!t || t.name !== 'id' || !t.closest) return null;
    var root = t.closest('.quickView, .quickShop, .quickshop-popup, [data-quick-view], [data-quickshop]');
    if (!root) return null;
    var ownForm = t.closest('form[action*="/cart/add"]');
    if (!ownForm) return null;
    return ownForm === quickProductForm(root) ? ownForm : null;
  }

  // FAZA 1 - PRE-GATE (capture): la schimbarea unui control de varianta, ascunde+gateaza dynamic checkout
  // IMEDIAT, inainte de handlerul nativ -> payment button nu ramane clickabil intre T0 si finalizarea nativa.
  document.addEventListener('change', function (e) {
    // Formularul principal: fie prin hidden [name=id] (semnal fiabil al temei), fie prin controlul vizibil.
    var form = quickIdForm(e.target) || variantControlForm(e.target);
    if (!form) return;
    setPaymentGate(form, true); // marker persistent MAI INTAI: CSS ascunde si nodurile payment re-injectate in acelasi ciclu
    var dyn = dynamicEls(form), i;
    for (i = 0; i < dyn.length; i++) { ourHide(dyn[i], true); ourGate(dyn[i], true); }
  }, true);

  // FAZA 2 - APLICARE FINALA (bubble, SINCRON): dupa ce handlerul nativ a actualizat
  // currentVariant / [name=id] / CTA / inventar. Fara setTimeout / debounce / polling.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.name === 'quantity') return; // cantitatea nu schimba disponibilitatea
    if (t && t.name === 'id') {
      // Hidden [name=id]: acceptat DOAR daca este formularul principal QV/QS (installment/PDP -> ignorate).
      var idForm = quickIdForm(t);
      if (idForm) applySafe(idForm);
      return;
    }
    var form = variantControlForm(t);
    if (form) { applySafe(form); return; }
    var f = t && t.closest ? t.closest('form[action*="/cart/add"]') : null;
    if (f) { applySafe(f); return; }
    // Fallback preexistent (independent de modal): schimbare in afara unui formular, ex. selector varianta PDP.
    setTimeout(scanAll, 120);
  });
  // Fallback preexistent: deschiderea Quick View/Quick Shop (injectare modal) + click pe selectorul de varianta.
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-open-quick-view-popup],[data-quickshop-popup],.variant-picker,variant-radios,.single-option')) {
      setTimeout(scanAll, 150); setTimeout(scanAll, 400);
    }
  });

  // Popup-uri injectate dinamic (Quick View / Quick Shop).
  // Reactioneaza doar cand se adauga noduri relevante (formulare / date), nu la
  // propriile modificari (input-uri de proprietati, textul mesajului) -> fara bucla.
  var pending;
  var REL_SEL = 'form[action*="/cart/add"], .drt-av-data, ' + PAYMENT_SEL;
  function hasRelevant(nodes) {
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.nodeType !== 1) continue;
      if (n.matches && n.matches(REL_SEL)) return true;
      if (n.querySelector && n.querySelector(REL_SEL)) return true;
    }
    return false;
  }
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (hasRelevant(muts[i].addedNodes)) {
        clearTimeout(pending);
        pending = setTimeout(scanAll, 150);
        return;
      }
    }
  });
  function start() {
    injectPaymentGateStyle();
    scanAll();
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
